import svg from "./candidate-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const CandidateIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.candidate.main,
  { viewBox: "0 0 36 36" }
);

export default CandidateIcon;
